var _defs, _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolPack348({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 3,
    y: 2.96,
    width: 10,
    height: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M4.39,10.74V5.37H7.57V6H5V7.65H7.4v.63H5v1.83h2.7v.63Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8.28,9l.55,0a1.57,1.57,0,0,0,.2.69,1.12,1.12,0,0,0,.44.39,1.41,1.41,0,0,0,.65.15,1.17,1.17,0,0,0,.81-.25.85.85,0,0,0,.29-.66.82.82,0,0,0-.11-.42.87.87,0,0,0-.31-.29,6.67,6.67,0,0,0-.91-.32A3,3,0,0,1,9,7.88a1.33,1.33,0,0,1-.41-.47,1.51,1.51,0,0,1-.14-.65,1.44,1.44,0,0,1,.42-1.07A1.57,1.57,0,0,1,10,5.28a1.79,1.79,0,0,1,.86.19,1.34,1.34,0,0,1,.57.56,1.79,1.79,0,0,1,.22.85l-.56,0a1.14,1.14,0,0,0-.31-.77A1.06,1.06,0,0,0,10,5.9a1.1,1.1,0,0,0-.75.23A.68.68,0,0,0,9,6.7a.63.63,0,0,0,.19.5,2.14,2.14,0,0,0,.85.37,5.54,5.54,0,0,1,.92.31,1.54,1.54,0,0,1,.61.54,1.56,1.56,0,0,1,.2.8,1.69,1.69,0,0,1-.21.84,1.56,1.56,0,0,1-.59.58,1.93,1.93,0,0,1-.9.19,1.75,1.75,0,0,1-1.3-.49A1.86,1.86,0,0,1,8.28,9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolPack348);
export default __webpack_public_path__ + "static/media/Symbol_pack_348.82acf1ff504009044cb2ec0257877cc4.svg";
export { ForwardRef as ReactComponent };